// extracted by mini-css-extract-plugin
export default {"wrapper":"Slider_wrapper__+CsKb","bubble":"Slider_bubble__zefCw","polygon":"Slider_polygon__6tj+w"};